import { Employee } from '@app/models/employee/employee.model';
import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { ApplicantInterviews } from '@app/models/recruiting/applicant-interviews.model';
import { MultiAvatarColumn } from '@app/modules/table/classes/multi-avatar-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class InterviewersColumn extends MultiAvatarColumn<ApplicantInterviews> {
    title = 'applicant-tracker.interviews-table.interviewers';
    sortable = true;
    type: CellDisplay = CellDisplay.multiAvatar;

    getEmployees(applicantInterview: ApplicantInterviews): Employee[] {
        return applicantInterview.applicantInterviewers
            .map((applicantInterviewer: ApplicantInterviewers) => applicantInterviewer?.interviewer)
            .filter((item) => item !== null);
    }
}
